﻿import React from "react";
import { Container, Paper, Typography } from "@mui/material";

const extractQualifiers = (jsonProperties) => {
    if (!jsonProperties) return null;
    try {
        const parsed = JSON.parse(jsonProperties);
        const qualifiers = {
            ...(parsed.Qualifiers ?? {}),
        };
        return Object.keys(qualifiers).length > 0 ? qualifiers : null;
    } catch {
        return null;
    }
};

const buildDisplayText = (artifactData, qualifiers) => {
    if (artifactData === undefined) return "";
    try {
        const data = JSON.parse(artifactData);
        if (qualifiers) {
            data.Qualifiers = qualifiers;
        }
        return JSON.stringify(data, null, 2);
    } catch {
        return artifactData ?? "";
    }
};

const DetailDisplay = ({
    sourceGridRef,
    targetGridRef,
    verticalOffsetPx = 0,
    extraSpacePx = 0,
}) => {
    const sourceRows = sourceGridRef?.current?.getSelectedRows?.() ?? new Map();
    const sourceRow = Array.from(sourceRows.values())[0];
    const sourceQualifiers = extractQualifiers(sourceRow?.JSONProperties);
    const sourceDisplayText = buildDisplayText(sourceRow?.ArtifactData, sourceQualifiers);

    const targetRows = targetGridRef?.current?.getSelectedRows?.() ?? new Map();
    const targetRow = Array.from(targetRows.values())[0];
    const targetQualifiers = extractQualifiers(targetRow?.JSONProperties);
    const targetDisplayText = buildDisplayText(targetRow?.ArtifactData, targetQualifiers);

    return (
        <Container
            sx={{
                paddingTop: "20px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "flex-start",
                width: "100%",
                position: "relative",
                zIndex: 2,
                mt: `calc(${verticalOffsetPx / 2}px + ${extraSpacePx}px)`,
            }}
        >
            <Paper sx={{ width: "40%", minHeight: "200px" }}>
                <Typography>Details:</Typography>
                <pre>{sourceDisplayText}</pre>
            </Paper>
            <Paper sx={{ width: "40%", minHeight: "200px" }}>
                <Typography>Details:</Typography>
                <pre>{targetDisplayText}</pre>
            </Paper>
        </Container>
    );
};

export default DetailDisplay;